// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2APRG","content":"styles_content__1un2H"};